var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34884 7.99999C3.34884 7.48036 3.43702 6.98218 3.59442 6.5149L0.839442 4.45599C0.302512 5.5229 0 6.72508 0 7.99999C0 9.27381 0.302139 10.4753 0.838326 11.5414L3.59181 9.47854C3.43591 9.01345 3.34884 8.51708 3.34884 7.99999Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18605 3.27273C9.33954 3.27273 10.3814 3.67273 11.2 4.32727L13.5814 2C12.1302 0.763636 10.2698 0 8.18605 0C4.95108 0 2.1708 1.81055 0.839447 4.456L3.59442 6.51491C4.22921 4.62909 6.0387 3.27273 8.18605 3.27273Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18605 12.7273C6.0387 12.7273 4.22921 11.3709 3.59442 9.48511L0.839447 11.5437C2.1708 14.1895 4.95108 16 8.18605 16C10.1827 16 12.0889 15.3062 13.5196 14.0062L10.9046 12.0277C10.1667 12.4826 9.23759 12.7273 8.18605 12.7273Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.00002C16 7.52729 15.9256 7.0182 15.814 6.54547H8.18605V9.63638H12.5767C12.3572 10.6902 11.7596 11.5004 10.9046 12.0277L13.5196 14.0062C15.0225 12.6411 16 10.6077 16 8.00002Z",
    fill: "#4285F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.c9bf2538.svg";
export { ForwardRef as ReactComponent };